<template>
  <section class="ppt-blog">
    <header>
      <h1 class="page-header">Blog</h1>
    </header>
    <blog-post-link
      title="Prior probability and estimating your winrate"
      date="10/1/19"
      path="/blog/prior-probability-and-estimating-your-winrate"
    />
    <blog-post-link
      title="Summary of Pokers 1% by Ed Miller"
      date="10/1/19"
      path="/blog/summary-of-pokers-one-percent"
    />
    <blog-post-link
      title="Zoom out"
      date="9/24/19"
      path="/blog/zoom-out"
    />
    <blog-post-link
      title="Spaced repetition and poker"
      date="9/24/19"
      path="/blog/spaced-repetition-and-poker"
    />
    <hr>
    <subscribe-to-blog />
  </section>
</template>

<script>
import BlogPostLink from '@/components/blog/blog-post-link';
import SubscribeToBlog from '@/components/blog/subscribe-to-blog';

export default {
  name: 'ppt-blog',
  components: {
    'blog-post-link': BlogPostLink,
    'subscribe-to-blog': SubscribeToBlog,
  },
};
</script>

<style lang="scss" scoped>
  .blog-post-link {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/blog/blog.vue